import { UseQueryResult, useQuery } from "react-query";
import { PericiaToUpdateDTO } from "../../../../shared/dto/pericia/update-pericia";
import { Pericia, updatePericiaMechanic } from "../../../../entities/pericia";

export const queryKeys = {
  updatePericiaMechanic: (pericia: PericiaToUpdateDTO, enabled: boolean) => ["updatePericiaMechanic", [pericia, enabled]]
};

export function useUpdatePericiaMechanic(pericia: Pericia, enabled: boolean): UseQueryResult<string, Error> {
  const periciaToUpdate: PericiaToUpdateDTO = {
    id: pericia.id,
    car: pericia.car,
    costumer: pericia.costumer,
    pricePerHour: pericia.pricePerHour,
    date: pericia.date,
    carParts: pericia.carParts,
    insuranceHours: pericia.insuranceHours,
    totalHours: pericia.totalHours,
    totalPrice: pericia.totalPrice,
    costumerPrice: pericia.costumerPrice,
    unmountPrice: pericia.unmountPrice,
    addtionalCost: pericia.addtionalCost,
    addtionalCostDescription: pericia.addtionalCostDescription,
    shouldUnmount: pericia.shouldUnmount,
    finished: pericia.finished,
    done: pericia.done,
    billed: pericia.billed,
    isPriceCalculated: pericia.isPriceCalculated,
    isEditable: pericia.isEditable,
    priceVersion: pericia.priceVersion
  };

  return useQuery(queryKeys.updatePericiaMechanic(periciaToUpdate, enabled), () => updatePericiaMechanic(periciaToUpdate), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled
  });
}
